import { type YoutubeVideoData } from '@/api/ai/youtube/types';
import { useFormattedViewCount, useVideoDistanceToNow } from '../hooks';
export const YoutubeInfo = ({
  videoData
}: {
  videoData: YoutubeVideoData;
}) => {
  const formattedViewCount = useFormattedViewCount(videoData.viewCount);
  const formattedDate = useVideoDistanceToNow(videoData.publishedAt);
  return <div className="flex flex-col gap-2xs" data-sentry-component="YoutubeInfo" data-sentry-source-file="YoutubeInfo.tsx">
      {/* 제목 */}
      <h3 className="line-clamp-2 text-body-lg-semibold text-gray-900">
        {videoData.title}
      </h3>

      {/* 채널명, 조회수, 업로드 날짜 */}
      <div className="flex items-center gap-3xs text-body-sm-medium text-alternative">
        <div className="flex items-center gap-3xs">
          <img src={videoData.channelThumbnailUrl} alt={videoData.channelTitle} className="size-[20px] rounded-full" />
          <span>{videoData.channelTitle}</span>
        </div>
        <span>•</span>
        <span>{formattedViewCount}</span>
        <span>•</span>
        <span>{formattedDate}</span>
      </div>
    </div>;
};